export enum MultipleInstrumentReservations {
  NotAllowed = 0,
  AllowedDefaultMultiple = 1,
  AllowedDefaultSingle = 2,
}
